module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(!_vm.print && _vm.loaded) ? _c('div', {
    staticClass: "page-container"
  }, [_c('md-progress-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.progress),
      expression: "progress"
    }],
    staticClass: "md-accent",
    attrs: {
      "id": "progress-bar",
      "md-mode": "indeterminate"
    }
  }), _c('md-app', {
    class: {
      'no-padding': !_vm.showRight && _vm.sidebar
    }
  }, [(_vm.logged) ? _c('md-app-toolbar', {
    staticClass: "md-dense md-primary main-toolbar",
    attrs: {
      "id": "main-toolbar",
      "md-elevation": "1"
    }
  }, [_c('toolbar', {
    attrs: {
      "sidebar": _vm.sidebar
    }
  })], 1) : _vm._e(), _c('md-app-content', {
    class: {
      'left-offset': _vm.sidebar
    },
    attrs: {
      "id": "main"
    }
  }, [(_vm.logged) ? _c('div', {
    staticClass: "sidebar",
    class: {
      'active': _vm.sidebar
    }
  }, [_c('main-menu')], 1) : _vm._e(), _c('div', {
    staticClass: "md-layout md-alignment-top-center",
    attrs: {
      "id": "main-layout"
    }
  }, [_c('div', {
    staticClass: "md-layout-item md-content center",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('router-view')], 1), _c('transition', {
    attrs: {
      "name": "slideright",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRight),
      expression: "showRight"
    }],
    staticClass: "md-layout-item md-content right",
    style: (_vm.rightPanelStyle),
    attrs: {
      "md-theme": "white"
    }
  }, [_c('router-view', {
    attrs: {
      "name": "right"
    }
  })], 1)]), _c('dynamic-right-panel')], 1)])], 1)], 1) : _vm._e(), (_vm.print && _vm.loaded) ? _c('div', {
    attrs: {
      "id": "print-view"
    }
  }, [_c('router-view')], 1) : _vm._e(), _c('Snackbar'), _c('ZModalAlert')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd26cd6c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1249
// module chunks = 0